<template>
    <div ref="content">
        <div class="menu_top padding_bottom_64">
            <div class="cart_suggesttitle">{{$t('personal.shoppingcart')}}</div>
            <div v-if="cartlistdata.length >0">
                <div class="cartbox display_flex  justify-content_flex-justify">
                    <div>
                        <div class="inline-block padding_left_24">
                            <span class="inline-block  vertical-middle cursor_p" v-bind:class="[allselected?'icon_round_active':'icon_round']" @click="chooseall()"></span><span class="padding_left_16 inline-block vertical-middle cursor_p" @click="chooseall()">{{$t('personal.chooseall')}}</span>
                        </div>
                        <div class="inline-block padding_left_394">{{$t('order.orderproduct')}}</div>
                    </div>
                    <div>
                        <div class="inline-block padding_left_430">{{$t('order.danjia')}}</div>
                        <div class="inline-block padding_left_72">{{$t('order.orderocaozuo')}}</div>
                    </div>
                </div>
                <div class="cartlist">
                    <div v-for="(item,index) in cartlistdata" class="cartlist_Item display_flex  justify-content_flex-justify align-items_center" @click="choose(item,index)">
                        <div class="inline-block padding_left_24">
                            <span class="inline-block vertical-middle" v-bind:class="{'icon_round':!item.choosestauts ,'icon_round_active': item.choosestauts}"></span>
                        </div>
                        <div class="cartlist_Item_R display_flex  align-items_center justify-content_flex-justify">
                            <div class="display_flex  align-items_center justify-content_flex-justify width_850">
                                <div class="display_flex  align-items_center ">
                                    <div  :class="['roundType',{'eng':currentlang == 'eng'}]">{{rank_type[item.prdType]}}</div>
                                    <div class="carttitle">
                                        <div class="title">{{item.title}}</div>
                                    </div>
                                </div>
                                
                                <div class="price">¥ {{item.discountPrice}}</div>
                            </div>
                            
                            <div class=" delbtn" @click.stop="del(item,index)">{{$t('personal.del')}}</div>
                        </div>
                    </div>
                    
                </div>
                <div class="cartbox_pay margin_top_32 display_flex  justify-content_flex-justify">
                    <div>
                        <div class="inline-block padding_left_24">
                            <span class="inline-block  vertical-middle cursor_p" v-bind:class="[allselected?'icon_round_active':'icon_round']" @click="chooseall()"></span><span class="padding_left_16 inline-block vertical-middle cursor_p" @click="chooseall()">{{$t('personal.chooseall')}}</span>
                        </div>
                        <div class="inline-block margin_left_32  cursor_p" @click="totaldel()">{{$t('order.desc10')}}</div>
                    </div>
                    
                    <div>
                        <span class="">{{$t('personal.maypay')}}：</span>
                        <span class="padding_left_30 totalprice">¥ {{totalamount}}</span>
                        <div class="paybtn" @click="jumppay('/pay')">{{$t('personal.pay')}}</div>
                    </div>
                </div>
            </div>
            <div v-if="cartlistdata.length  == 0" class="empty">
                <img src="https://p1.fishqc.net/FqVLmUKK1YJNCfTM5QYuI7WTSf9X">
                <div>{{$t('personal.empty_cart')}}</div>
            </div>
           
        </div>
    </div>
</template>
<style lang="scss" scoped>
@import "@/assets/css/mixin.scss";
.padding-32 {
    padding: 32px 0;
    box-sizing: border-box;
}

.order_menu {
    background: #F8FBFD;
    height: 64px;
    font-size: 24px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #60DEB4;
    text-align: left;
    .order_tab {
        width: 160px;
        height: 60px;
        color: #A8A8AD;
        line-height: 60px;
        cursor: pointer;
        border-top: 4px solid #F8FBFD;
        text-align: center;

        &.active {
            background: #fff;
            border-top: 4px solid #60DEB4;
        }

    }
}

.more {
    width: 246px;
    height: 48px;
    text-align: center;
    line-height: 48px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #51515C;
    letter-spacing: 4px;
    cursor: pointer;
    background: url('../../assets/images/arr.png') no-repeat 210px 20px;
    background-color: #FFFFFF;
}
// 购物车
.cart_suggesttitle {
    font-size: 32px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #262633;
    line-height: 32px;
    text-align: left;
    padding:32px 0;
    box-sizing: border-box;
}
.padding_left_394{
    padding-left:394px;
    box-sizing:border-box;
}
.padding_left_430{
    // padding-left:326px;
    box-sizing:border-box;
}

.padding_left_72{
    padding-left:72px;
    box-sizing:border-box;
}

.padding_left_24{
    padding-left:24px;
    box-sizing:border-box;
}

.padding_left_16{
    padding-left:16px;
    box-sizing:border-box;
}

.padding_left_70{
    padding-left: 70px;
    box-sizing: border-box;
}

.padding_left_32{
     padding-left: 32px;
    box-sizing: border-box;
}

.margin_top_32{
    margin-top: 32px;
}

.icon_round{
    width: 24px;
    height: 24px;
    background-repeat: no-repeat;
    background-position: center;
    background-image: url('http://p1.fishqc.net/Fi866XKEL2K1enaGLMbP7UEoGszc');
    background-size: contain;
    cursor: pointer;
}
.icon_round_active{
    width: 24px;
    height: 24px;
    background-repeat: no-repeat;
    background-position: center;
    background-image: url('http://p1.fishqc.net/Fi7H0WxhAwOc4HazwhaaQ9n7tv_9');
    background-size: contain;
}
.cartbox_pay{
    height: 64px;
    line-height: 64px;
    background: #f8fbfd;
    font-size: 14px;
    font-family: PingFangSC-Regular,PingFang SC;
    font-weight: 400;
    color: #888;
    text-align: left;
    .totalprice{
        font-size: 24px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FF7467;
        margin-left: 30px;
    }
    .paybtn{
        width: 180px;
        height: 100%;
        line-height: 64px;
        background: #60DEB4;
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        text-align: center;
        display: inline-block;
        margin-left: 40px;
        vertical-align: top;
        cursor: pointer;
    }
}
.cartbox{
    height: 64px;
    line-height:64px;
    background: #F8FBFD;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #888888;
    text-align: left;
    padding-right: 130px;
    box-sizing: border-box;
    .totalprice{
        font-size: 24px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FF7467;
        margin-left: 30px;
    }
    .paybtn{
        width: 180px;
        height: 100%;
        line-height: 64px;
        background: #60DEB4;
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        text-align: center;
        display: inline-block;
        margin-left: 40px;
        vertical-align: top;
        cursor: pointer;
    }
}

.cartlist{

    .cartlist_Item{
        margin-top:24px;
        
        
        .cartlist_Item_R{
            width:1098px;
            height: 120px;
            background: #FFFFFF;
            border: 1px solid #F4F4F5;
            padding:0 126px 0 24px;
            box-sizing: border-box;
            cursor: pointer;
            &:hover{
                box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
            }
            .roundType{
                width: 72px;
                height: 72px;
                line-height:72px;
                color:#fff;
                border-radius: 50%;
                background-color: #60DEB4;
                font-size: 24px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                &.eng{
                    font-size: 16px;
                }
            }

            .carttitle{
                width: 650px;
                margin-left: 24px;
                text-align: left;
                .title{
                    font-size: 24px;
                    font-family: PingFangSC-Medium;
                    font-weight: 500;
                    color: #262633;
                    line-height: 36px;
                    @include linelimt(1);
                }
                .desc{
                    font-size: 14px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #888888;
                    line-height: 24px;
                    @include linelimt(1);
                    margin-top: 4px;
                }
            }

            .price{
                font-size: 18px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #FF7467;
                box-sizing: border-box;
            }

            .delbtn{
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #51515C;
            }
        }
    }
}

.width_850{
    width: 850px;
}

.empty{
    font-size: 24px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #262633;
    line-height: 50px;
    text-align: center;
    padding: 80px 0;
    box-sizing: border-box;
    position: absolute;
    left:50%;
    top:50%;
    transform: translate(-50%,-50%);
}

.margin_left_32{
    margin-left: 32px;
}
</style>
<script>
import Vue from 'vue'
// @ is an alias to /src
import banner from '@/components/banner.vue'
import { CartlistApi,delCartApi,multiDelCartApi} from '@/api/api.js'
import { myMixin } from '@/mixin/mixin.js'

export default {
    name: '',
    components: {
        banner,
    },
    mixins: [myMixin],
    data() {
        return {
            rankArr: [{
                    title: '我的榜单',
                    type: 'myrank',
                    icon: '',
                    iconActive: ''
                },
                {
                    title: '我的报告',
                    type: 'myreport',
                    icon: '',
                    iconActive: ''
                },


            ],
            currenttap: 'myrank',
            cartlistdata:[],
            allselected:false,
            totalamount:0,  //总额
            currentlang:''
            
        }
    },
    computed: {
        carts2(){
            return this.$store.state.shopcart
        }
        // totalprice(){  //计算总额
        //     var price =  0;
        //     this.cartlistdata.forEach((val)=>{
        //         if(val.choosestauts){
        //             price  = price + Number(val.discountPrice)
        //         }
                
        //     })
        //     return price
        // },
    },
    watch:{
        'cartlistdata':function(){    
            this.$nextTick(function(){
                //渲染完成
                var height = this.$refs.content.offsetHeight
                this.footerAuto(height)
               
            })
        },

    },
    mounted() {
        this.currentlang  = window.localStorage.getItem("LOCALE") ||  'chs'
        this.cartlist()

    },
    methods: {
        tapchoose(item) {
            this.currenttap = item
        },
        // 获取购物车列表
        cartlist(){
            CartlistApi({
                lang:window.localStorage.getItem("LOCALE") ||  'chs'
            }).then(res => {
                if (res.code == 200) {
                    this.$store.commit('getcartsnum',res.data.length)
                    this.cartlistdata =  res.data
                    this.cartlistdata.forEach((val)=>{
                        val.choosestauts = false
                    })
                }else if(res.code == '204'){ // 数据为空
                    this.cartlistdata = []
                }else if(res.code == '401'){ //未登录
                    this.gorouter('/login?region=0')
                } else {
                    this.toast(res.message)
                }
            })
        },
        totalprice(){  //计算总额
            this.totalamount =  0;
            this.cartlistdata.forEach((val)=>{
                if(val.choosestauts){
                    this.totalamount  = this.totalamount + Number(val.discountPrice)
                }
                
            })
            return this.totalamount
        },
        // 删除该列购物清单
        del(item,index){
            console.log(item,index)
            delCartApi({
                prdId:item.prdId,
                prdType:item.prdType
            }).then(res => {
                if (res.code == 200) {
                    this.cartlistdata.splice(index,1)
                    console.log(this.cartlistdata)
                    this.$store.commit('getcartsnum',this.carts2-1)
                    this.$forceUpdate()
                    this.totalprice()
                } else {
                    this.toast(res.message)
                }
            })
        },
        // 选中该购物清单
        choose(item,index){
            if(this.cartlistdata[index].choosestauts){
                this.$set(this.cartlistdata[index],'choosestauts',false)
                this.$forceUpdate()
                this.totalprice()
            }else{
                this.$set(this.cartlistdata[index],'choosestauts',true)
                this.$forceUpdate()
                this.totalprice()
            }
            
            console.log(this.cartlistdata)
        },
        // 全选
        chooseall(){
            
            if(!this.allselected){
                this.allselected = true
                for(var i=0;i<this.cartlistdata.length;i++){
                    if(!this.cartlistdata[i].choosestauts){

                    }
                    this.$set(this.cartlistdata[i],'choosestauts',true)
                    this.$forceUpdate()
                    this.totalprice()
                }
            }else{
                this.allselected = false
                for(var i=0;i<this.cartlistdata.length;i++){
                    this.$set(this.cartlistdata[i],'choosestauts',false)
                    this.$forceUpdate()
                    this.totalprice()
                }
            }
            // for(var i=0;i<this.cartlistdata.length;i++){
            //     if(!this.cartlistdata[i].choosestauts){
            //         this.$set(this.cartlistdata[i],'choosestauts',true)
            //         this.$forceUpdate()
            //     }
                
            // }

        },
        // 批量删除
        totaldel(){

            var prdListString = []

            this.cartlistdata.forEach((val)=>{
                if(val.choosestauts){
                    prdListString.push({
                        prdId:val.prdId,
                        prdType:val.prdType
                    })
                }
            })

            if(prdListString.length == 0){
                this.toast('请选择需要删除的列表')
                return
            }

            multiDelCartApi({
                prdList:JSON.stringify(prdListString)
            }).then(res => {
                if (res.code == 200) {
                    // this.$store.commit('getcartsnum',this.carts1-prdListString.length)
                    this.cartlist()
                    this.$forceUpdate()
                    this.totalprice()

                } else {
                    this.toast(res.message)
                }
            })
            
        },
        jumppay(url){
            var prdListString = []

            this.cartlistdata.forEach((val)=>{
                if(val.choosestauts){
                    prdListString.push({
                        prdId:val.prdId,
                        prdType:val.prdType,
                        title:val.title,
                        discountPrice:val.discountPrice

                    })
                }
            })
            window.sessionStorage.setItem('orderlist',JSON.stringify(prdListString));
            this.$router.push({
                path:url,

            })
        }
    }
}
</script>